import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/layout/Header'
import Hero from './components/home/Hero'
import About from './components/home/About'
import Features from './components/home/Features'
import Events from './components/home/Events'
import Resources from './components/home/Resources'
import Contact from './components/home/Contact'
import Footer from './components/layout/Footer'
import ScrollToTop from './components/shared/ScrollToTop'
import Register from './pages/Register'
import './styles/global.css'

// Create Home component
const Home = () => {
  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <About />
        <Features />
        <Events />
        <Resources />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  )
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </Router>
  )
}

export default App 